module.exports = __webpack_public_path__ + "static/media/WRDivision4WordsE.8767bd3b.jpg";